export default __webpack_public_path__ + "static/images/assistenza-f44cadece6099b162ff4ebf14d3bdb5c.jpg";